import { render, staticRenderFns } from "./GExamListActionIcons.vue?vue&type=template&id=3774e7ec&scoped=true&"
import script from "./GExamListActionIcons.vue?vue&type=script&lang=ts&"
export * from "./GExamListActionIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774e7ec",
  null
  
)

export default component.exports